/**
 * Securidou — Product Reviews Component
 * Handles: CTA scroll, sort, star picker (click + keyboard), form validation.
 * Loaded with defer — DOM is ready when this runs.
 */
(function () {
  'use strict';

  function initProductReviews() {
    /* WRITE REVIEW CTA — scroll to form */
    document.querySelectorAll('.pr-btn-write').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.dataset.target);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    /* SORT SELECT */
    document.querySelectorAll('.pr-sort-select').forEach(function (select) {
      select.addEventListener('change', function () { sortReviews(this); });
    });

    /* STAR PICKER */
    var pickers = document.querySelectorAll('.pr-star-picker');
    pickers.forEach(function (picker) {
      var stars = picker.querySelectorAll('.pr-pick-star');
      var sectionId = picker.id.replace('pr-star-picker-', '');
      var hiddenInput = document.getElementById('pr-rating-input-' + sectionId);
      if (!hiddenInput) return;

      function setRating(val) {
        hiddenInput.value = val;
        stars.forEach(function (s) {
          var sv = parseInt(s.dataset.value);
          s.textContent = sv <= val ? '\u2605' : '\u2606';
          s.classList.toggle('active', sv <= val);
        });
        var errEl = document.getElementById('pr-err-rating-' + sectionId);
        if (errEl) errEl.textContent = '';
      }

      stars.forEach(function (star) {
        star.addEventListener('click', function () {
          setRating(parseInt(this.dataset.value));
        });

        star.addEventListener('mouseenter', function () {
          var val = parseInt(this.dataset.value);
          stars.forEach(function (s) {
            s.textContent = parseInt(s.dataset.value) <= val ? '\u2605' : '\u2606';
          });
        });
      });

      picker.addEventListener('mouseleave', function () {
        var current = parseInt(hiddenInput.value) || 0;
        stars.forEach(function (s) {
          var sv = parseInt(s.dataset.value);
          s.textContent = sv <= current ? '\u2605' : '\u2606';
        });
      });

      /* Keyboard: ArrowLeft/Right to change rating */
      picker.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var currentVal = parseInt(hiddenInput.value) || 0;
        var newVal;
        if (e.key === 'ArrowRight') {
          newVal = Math.min(currentVal + 1, 5);
        } else {
          newVal = Math.max(currentVal - 1, 1);
        }
        setRating(newVal);
        if (stars[newVal - 1]) stars[newVal - 1].focus();
      });
    });

    /* CHARACTER COUNT */
    document.querySelectorAll('.pr-textarea').forEach(function (ta) {
      var sectionId = ta.id.replace('pr-body-', '');
      var counter = document.getElementById('pr-chars-' + sectionId);
      ta.addEventListener('input', function () {
        if (counter) {
          var len = ta.value.length;
          counter.textContent = len + ' / 20 caract\u00e8res min.';
          counter.style.color = len >= 20 ? '#10b981' : '#9ca3af';
        }
      });
    });

    /* FORM VALIDATION */
    document.querySelectorAll('.pr-form-section form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var formSection = form.closest('.pr-form-section');
        if (!formSection) return;
        var sectionId = formSection.id.replace('pr-form-', '');
        var valid = true;

        var ratingInput = document.getElementById('pr-rating-input-' + sectionId);
        var nameInput = document.getElementById('pr-name-' + sectionId);
        var bodyInput = document.getElementById('pr-body-' + sectionId);

        var errRating = document.getElementById('pr-err-rating-' + sectionId);
        var errName = document.getElementById('pr-err-name-' + sectionId);
        var errBody = document.getElementById('pr-err-body-' + sectionId);

        if (errRating) errRating.textContent = '';
        if (errName) errName.textContent = '';
        if (errBody) errBody.textContent = '';

        if (!ratingInput || !ratingInput.value || parseInt(ratingInput.value) < 1) {
          if (errRating) errRating.textContent = 'Veuillez s\u00e9lectionner une note.';
          valid = false;
        }
        if (nameInput && nameInput.value.trim().length < 2) {
          if (errName) errName.textContent = 'Veuillez entrer votre pr\u00e9nom.';
          valid = false;
        }
        if (bodyInput && bodyInput.value.trim().length < 20) {
          if (errBody) errBody.textContent = 'Votre avis doit contenir au moins 20 caract\u00e8res.';
          valid = false;
        }

        if (!valid) {
          e.preventDefault();
          return;
        }

        ratingInput.setAttribute('name', 'contact[review_rating]');
      });
    });
  }

  /* SORT REVIEWS (global, called from change handler) */
  function sortReviews(select) {
    var sectionId = select.id.replace('pr-sort-', '');
    var list = document.getElementById('pr-list-' + sectionId);
    if (!list) return;
    var cards = Array.from(list.querySelectorAll('.pr-card'));
    cards.sort(function (a, b) {
      if (select.value === 'recent') {
        return (b.dataset.date || '').localeCompare(a.dataset.date || '');
      } else if (select.value === 'highest') {
        return parseInt(b.dataset.rating) - parseInt(a.dataset.rating);
      } else if (select.value === 'photos') {
        var aImg = a.dataset.hasImages === 'true' ? 1 : 0;
        var bImg = b.dataset.hasImages === 'true' ? 1 : 0;
        return bImg - aImg || (b.dataset.date || '').localeCompare(a.dataset.date || '');
      } else {
        return parseInt(a.dataset.rating) - parseInt(b.dataset.rating);
      }
    });
    cards.forEach(function (card) {
      list.appendChild(card);
    });
  }

  /* Init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductReviews);
  } else {
    initProductReviews();
  }
})();
